import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArcaptchaWidget } from "arcaptcha-react";
import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { Grid, Button, Typography, Box } from "@mui/material";
import { USERS_API } from "../api";
import { useRemainedSecond } from "../hooks";
import { ReactComponent as Logo1 } from "../assets/images/Logo_1.svg";
import Footer from "./Footer";
import { addErrorMessage } from "../slice";

function Terms() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const recaptcha = useRef();
  const [captchaToken, setCaptchaToken] = useState();
  const [captchaKey, setCaptchaKey] = useState(0);
  const { setRemained_second } = useRemainedSecond();

  const { mutate: sendVerification } = useMutation(
    ({ username, isByEmail }) => USERS_API.SendVerification(username, isByEmail, captchaToken),
    {
      onError: ({ response }) => {
        if (response.data?.data.validSeconds) {
          setRemained_second(parseInt(response.data.data.validSeconds));
          navigate("/verification-code");
        }
        setCaptchaKey((prev) => prev + 1);
        setCaptchaToken(null);
        recaptcha.current.reset();
      },
      onSuccess: ({ data }) => {
        setRemained_second(parseInt(data?.data.validSeconds));
        navigate("/verification-code");
      },
    },
  );

  const handleGoBack = () => {
    navigate("/gender-determination");
  };

  const handleAccept = () => {
    let actionType = window.sessionStorage.getItem("action-type");
    if (!captchaToken) {
      dispatch(
        addErrorMessage({ status: 400, data: { message: "لطفا من ربات نیستم را انتخاب کنید." } }),
      );
    } else {
      switch (actionType) {
        case "isByEmail":
          let email = window.sessionStorage.getItem("email");
          sendVerification({ username: email, isByEmail: true });
          break;
        case "isByPhoneNumber":
          let phoneNumber = window.sessionStorage.getItem("phoneNumber");
          sendVerification({ username: phoneNumber, isByEmail: false });
          break;
        default:
          break;
      }
    }
  };

  return (
    <Grid
      container
      maxWidth="1920px"
      width="100%"
      minHeight="100vh"
      bgcolor={{ xs: "#FFFFFF", sm: "#FAFAFA", md: "#FAFAFA" }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
      fontFamily="VazirMedium"
      position="relative"
    >
      <Box
        container
        width={{ xs: "100%", sm: "80%", md: "60%" }}
        bgcolor="#fff"
        borderRadius={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ boxSizing: "border-box" }}
        py={6}
        px={2}
        mt={{ xs: 0, sm: 5, md: 5 }}
        mb={{ xs: 0, sm: 2, md: 2 }}
        minWidth={{ xs: 0, sm: 0, md: 700 }}
      >
        <Box display="flex" flexDirection="column" alignItems="end">
          <Box
            display="flex"
            width="100%"
            flexDirection={{ xs: "column", sm: "column", md: "row-reverse" }}
            justifyContent="space-between"
            alignItems="center"
          >
            <Box
              display="flex"
              mb={{ xs: 8, sm: 8, md: 0 }}
              flex={1}
              justifyContent="center"
              alignItems="center"
            >
              <Logo1 />
            </Box>
            <Box flex={3} px={{ xs: 2, sm: 2, md: 5 }} sx={{ boxSizing: "border-box" }}>
              <Typography
                variant="h1"
                textAlign={{ xs: "center", sm: "center", md: "right" }}
                my={3}
              >
                شرایط استفاده از خدمات طرح هدا (همسان گزینی دانشگاهی ایران)
              </Typography>
              <ul dir="rtl" style={{ padding: 0 }}>
                <li
                  style={{
                    paddingBottom: "0.35rem",
                    color: "#000",
                    textAlign: "justify",
                  }}
                >
                  تکمیل کردن فرم اطلاعات متقاضی و ارسال آن به مرکز
                </li>
                <li
                  style={{
                    paddingBottom: "0.35rem",
                    color: "#000",
                    "&::marker": { color: "red", content: "/2022" },
                    textAlign: "justify",
                  }}
                >
                  اشتغال به تحصیل و یا دارا بودن مدرک تحصیلی در حداقل یکی از مقاطع تحصیلی کاردانی به
                  بالا
                </li>
                <li style={{ paddingBottom: "0.35rem", color: "#000", textAlign: "justify" }}>
                  با توجه به خانواده محور بودن طرح، لازم است متقاضی در تمامی مراحل معرفی با خانواده
                  خود هماهنگ باشد.
                </li>
                <li style={{ paddingBottom: "0.35rem", color: "#000", textAlign: "justify" }}>
                  مسئولیت صحت اطلاعات اعلام شده صرفاً بر عهده متقاضی است و مرکز هدا هیچ‌گونه
                  مسئولیتی در این رابطه نخواهد داشت. در طرح هدا تنها اطلاعات مربوط به مدارک بارگذاری
                  شده قابل احراز می‌‌‌باشد و بقیه اطلاعات صرفا بر مبنای خوداظهاری متقاضیان استوار
                  است. لذا موکداً به کلیه عزیزان توصیه می‌شود در صورت معرفی یک مورد، تحقیقات لازم و
                  کافی را در باره فرد معرفی شده انجام دهند.
                </li>
                <li style={{ paddingBottom: "0.35rem", color: "#000", textAlign: "justify" }}>
                  متقاضی متعهد می‌گردد که از شماره‌های تماس یا نشانی‌هائی که بعد از معرفی در اختیار
                  ایشان قرار می‌‌‌گیرد سوء استفاده نکرده و به هیچ وجه آن‌ها را در اختیار فرد دیگری
                  قرار ندهد. عواقب ناشی از تخلف از این بند بر عهده فرد متخلف بوده و حق پیگیری در
                  مراجع قانونی برای فرد متضرر مسلم و برقرار می‌باشد.
                </li>
                <li style={{ paddingBottom: "0.35rem", color: "#000", textAlign: "justify" }}>
                  در صورت معرفی دو نفر به یکدیگر
                  <strong style={{ color: "#000" }}> متقاضی آقا </strong> موظف است هر چه زودتر
                  (حداکثر ظرف مدت یک هفته) با خانم یا خانواده ایشان تماس گرفته و جهت ملاقات اولیه
                  هماهنگی نماید. طرفین موظفند نتیجه مذاکرات و ملاقات اولیه را به مرکز هدا اطلاع
                  دهند.
                </li>
                <li style={{ paddingBottom: "0.35rem", color: "#000", textAlign: "justify" }}>
                  چنانچه پس از مذاکرات اولیه<strong style={{ color: "#000" }}> متقاضی آقا </strong>{" "}
                  تمایل به ادامه آشنایی نداشت ، لازم است طی تماس تلفنی و یا پیامکی محترمانه به خانم
                  و یا خانواده ایشان ضمن تشکر نتیجه را به اطلاع ایشان برساند.
                </li>
                <li style={{ paddingBottom: "0.35rem", color: "#000", textAlign: "justify" }}>
                  توصیه می‌‌شود چنانچه بعد از ملاقات اولیه طرفین مایل به ادامه آشنایی بودند، پس از
                  جلسات چهارم یا پنجم گفتگو، هردو به اتفاق به یک مرکز مشاوره معتبر مراجعه نموده و از
                  نظرات تخصصی مشاوران قبل از ازدواج بهره‌‌گیری نمایند.
                </li>
                <li style={{ paddingBottom: "0.35rem", color: "#000", textAlign: "justify" }}>
                  هدف مرکزهدا این است که با ایجاد یک بانک اطلاعاتی از جوانان تحصیل‌‌کرده متقاضی
                  ازدواج ، گامی در جهت تسهیل و یافتن همسان مناسب برای متقاضیان بر‌‌دارد. اولویت
                  پیگیری پرونده هر متقاضی صرفاً بر اساس تکمیل و ارسال فرم ثبت نام به مرکز و انجام
                  جلسه مصاحبه و همکاری منطقی متقاضی (نداشتن خواسته‌‌های غیر منطقی) می‌‌باشد. لذا
                  امکان پیگیری درخواست‌‌های خارج از نوبت مقدور نمی‌‌‌باشد.
                </li>
                <li style={{ paddingBottom: "0.35rem", color: "#000", textAlign: "justify" }}>
                  مرکز هدا جستجوی همسان‌‌یابی را از داده‌‌های بانک اطلاعاتی که در اختیار دارد انجام
                  می‌‌دهد و هیچ‌‌‌گونه تعهدی مبنی بر اینکه حتما فرد مناسبی به متقاضی معرفی گردد
                  ندارد.
                </li>
                <li style={{ paddingBottom: "0.35rem", color: "#000", textAlign: "justify" }}>
                  خدمات مرکز هدا صرفاً برای مجردین (افراد مجرد، مطلقه، همسر فوت شده) و در زمینه
                  ازدواج دائم می‌‌باشد و هیچ‌‌گونه خدماتی در ارتباط با ازدواج موقت و یا تعدد زوجات
                  ندارد.
                </li>
                <li style={{ paddingBottom: "0.35rem", color: "#000", textAlign: "justify" }}>
                  چنان‌‌چه متقاضی موارد معرفی شده را به دلایل غیر منطقی رد کند (حداکثر 5 مورد)
                  پرونده ایشان موقتاً بسته خواهد شد و در صورت تکرار حذف می‌‌گردد.
                </li>
                توصیه می‌‌شود به هنگام تأیید یا عدم تأیید موارد معرفی شده حتماً شرایط کلی خود و
                خانواده خود و کفویت‌‌ها را مد نظر داشته باشید.
              </ul>
              <Grid
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
                alignContent="flex-end"
              >
                <ArcaptchaWidget
                  site-key="yxdswqtakz"
                  key={captchaKey}
                  ref={recaptcha}
                  hl="fa"
                  callback={(token) => {
                    setCaptchaToken(token);
                  }}
                />
              </Grid>
              <Box
                display="flex"
                justifyContent={{ xs: "space-around", sm: "space-around", md: "flex-end" }}
                width="100%"
                mt={3}
                mb={{ xs: 3, sm: 0, md: 0 }}
              >
                <Button
                  onClick={handleGoBack}
                  variant="m2"
                  sx={{ m: 1, width: "30%", flex: { xs: 1, sm: 1, md: "none" } }}
                >
                  قبلی
                </Button>
                <Button
                  onClick={handleAccept}
                  variant="m1"
                  sx={{ m: 1, width: "30%", flex: { xs: 1, sm: 1, md: "none" } }}
                >
                  موافقم
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Footer />
    </Grid>
  );
}

export default Terms;
